module.exports = __webpack_public_path__ + "static/media/Joker1.7ce690e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Joker1.svg
// module id = 85
// module chunks = 0